Model = require('./model')
PagedCollection = require('base/paged-collection')

class EmergencyCollection extends PagedCollection
  model: Model
  url: 'emergency'

module.exports = EmergencyCollection
